import React from 'react';

export const AskRovoIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M7.32082 0.180234C7.74137 -0.0600783 8.25764 -0.0600779 8.67819 0.180234L14.4919 3.50235C14.9181 3.7459 15.1811 4.19916 15.1811 4.69005V11.31C15.1811 11.8008 14.9181 12.2541 14.4919 12.4976L8.67819 15.8198C8.25764 16.0601 7.74137 16.0601 7.32082 15.8198L1.50712 12.4976C1.08091 12.2541 0.817871 11.8008 0.817871 11.31V4.69005C0.817871 4.19916 1.08091 3.7459 1.50712 3.50235L7.32082 0.180234Z"
			fill="#BF63F3"
		/>
		<mask
			id="mask0_3627_38412"
			mask-type="alpha"
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="16"
			height="16"
		>
			<path
				d="M7.32131 0.180234C7.74186 -0.0600783 8.25813 -0.0600779 8.67868 0.180234L14.4924 3.50235C14.9186 3.7459 15.1816 4.19916 15.1816 4.69005V11.31C15.1816 11.8008 14.9186 12.2541 14.4924 12.4976L8.67868 15.8198C8.25813 16.0601 7.74186 16.0601 7.32131 15.8198L1.50761 12.4976C1.08139 12.2541 0.818359 11.8008 0.818359 11.31V4.69005C0.818359 4.19916 1.08139 3.7459 1.50761 3.50235L7.32131 0.180234Z"
				fill="#BF63F3"
			/>
		</mask>
		<g mask="url(#mask0_3627_38412)">
			<path
				d="M1.54985 23.7265C2.51673 21.8761 3.92855 20.4256 5.78776 19.438C7.64697 18.4504 9.80601 18.0274 11.9919 18.2789L0.232371 -3.40698C-1.71763 -3.05413 -3.61363 -2.40306 -5.43841 -1.43374C-7.26319 -0.464414 -8.83231 0.695987 -10.1949 2.06194L1.55476 23.7297L1.54985 23.7265Z"
				fill="#82B536"
			/>
			<path
				d="M8.32996 10.605C5.08544 11.9474 2.60753 14.1648 2.50661 17.2336C2.50661 17.2336 2.50834 17.2493 2.5067 17.2571C2.50006 17.4851 2.50431 17.7156 2.52528 17.951C2.52613 17.953 2.52697 17.955 2.52782 17.957C2.54755 18.1952 2.58193 18.4391 2.63013 18.6867C2.64247 18.7449 2.66068 18.8055 2.67303 18.8637C2.71727 19.0613 2.76151 19.2589 2.82541 19.4624C2.91006 19.7324 3.0085 20.0061 3.12662 20.2858C3.34515 20.8031 3.60149 21.2649 3.87811 21.6761C4.24638 22.223 4.65025 22.6801 5.05256 23.0581C5.15366 23.1524 5.25307 23.2426 5.35496 23.3272C5.82852 23.6475 6.52024 24.0723 7.67929 24.6111C8.43636 24.9643 9.39801 25.3666 10.6295 25.8215C11.6142 24.3229 13.4162 23.1573 15.1026 21.8517C16.434 20.8198 17.6899 19.7018 18.4057 18.2628C19.0622 16.9446 19.0793 15.302 18.3596 13.5981C16.5583 9.33344 12.571 8.84782 8.33329 10.6012L8.32996 10.605Z"
				fill="#FCA700"
			/>
			<path
				d="M15.5504 -10.1485L-3.75363 -6.70403C-3.75363 -6.70403 -1.76588 2.0296 -6.08056 9.98028C-5.48977 10.0251 -4.8921 10.0522 -4.28777 10.0438C6.82615 9.8888 15.707 0.847865 15.5504 -10.1521L15.5504 -10.1485Z"
				fill="#1868DB"
			/>
		</g>
		<path
			d="M7.56286 3.61825C7.87582 3.4455 8.2578 3.44868 8.56822 3.62777L11.5883 5.37137C11.9043 5.55372 12.1 5.89203 12.1 6.25648V9.74374C12.1 10.1096 11.9055 10.4465 11.5885 10.6287L9.31833 11.9394C9.3233 11.9254 9.32804 11.9114 9.33255 11.8972C9.37469 11.7666 9.39702 11.6285 9.39702 11.4874V8.00011C9.39702 7.52104 9.14221 7.07926 8.7266 6.84027L7.03432 5.86367V4.51286C7.03432 4.40642 7.05078 4.30244 7.08192 4.20401C7.15847 3.96578 7.3213 3.75955 7.54405 3.63081L7.54473 3.63042C7.55112 3.62673 7.55719 3.62265 7.56286 3.61825Z"
			fill="white"
		/>
		<path
			d="M6.79433 4.06421L4.52416 5.37488C4.20715 5.55713 4.0127 5.89395 4.0127 6.25985V9.7471C4.0127 10.1116 4.20829 10.4498 4.52436 10.6322L7.54444 12.3758C7.85486 12.5549 8.23686 12.5581 8.5498 12.3853C8.55547 12.3809 8.5615 12.3769 8.56789 12.3732C8.79089 12.2445 8.95396 12.0382 9.03064 11.7999C9.06185 11.7014 9.07834 11.5973 9.07834 11.4907V10.1399L7.38617 9.16338C6.97063 8.92437 6.71564 8.4825 6.71564 8.00348V4.51622C6.71564 4.37529 6.73791 4.23742 6.77994 4.10692C6.7845 4.09259 6.7893 4.07835 6.79433 4.06421Z"
			fill="white"
		/>
	</svg>
);
